import { Button, ButtonProps } from '@slal/ui/buttons';

export const SubmitButton = ({ children, ...otherProps }: ButtonProps) => (
    <Button size="large" type="submit" {...otherProps}>
        {children || `Next`}
    </Button>
);
